import {
  Box,
  CardMedia,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { Colors } from "helpers/Consts";
// import { Close } from "@mui/icons-material";

type Props = {
  open: boolean;
  handleClose: () => void;
};

function VideoDialog({ open, handleClose }: Props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Dialog open={open} fullScreen={fullScreen}>
      <DialogTitle color={Colors.orangePrimary}>
        <Box display="flex" alignItems="center">
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 4,
          }}
        >
          <Box>
            <CardMedia
              component="video"
              image={require("assets/videos/order_sent.mp4")}
              autoPlay={true}
              onEnded={() => handleClose()}
            />
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              fontWeight={400}
              color="primary"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "18px",
                  md: "20px",
                },
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              Seu pedido foi enviado, logo ele será preparado.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default VideoDialog;
